<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<div class="figure">
<img alt="image1" class="img-centre" src="Images/file0.jpg" style="width:2.5252in"/>
<p class="caption">image1</p>
</div>
<p>Kevin Mullin enlisted in the British Army aged fifteen years and eight months. He served in several conflict areas and operations around the globe, then at the age of thirty-four, he left the service and became a private military operator. Kevin was contracted to the United States Department of Defense, securing and protecting US Military bases and assets in Afghanistan. Kevin worked there for four years before moving to one of the most valuable targets in Afghanistan in the heart of Kabul – The Serena Hotel. Kevin studied NLP within the British Army and gained a wealth of knowledge and experience, training the trainers in the methods of approaches to NLP. Having suffered the loss of both his brother and mother, he was crippled with anxiety for many years. Kevin searched relentlessly for new, dynamic ways to beat it.</p>
<p>Having taken an apprenticeship with Ali Campbell, Kevin finally found what he was looking for. He understudied and role modelled Ali to great effect. In June 2017, Kevin opened his very own NLP practice based in Central Scotland. The practice has received rave reviews about Kevin’s new, dynamic and direct approach. He has helped thousands of clients become anxiety-free. Kevin has gained plaudits from Italy, Dubai and America for his dynamic and enthusiastic approach to motivational speaking and helping businesses and organisations flourish and grow. He is also a full-time parent. He raises his children with the approach he takes in life and in his crusade to help everyone in the battle with anxiety. Drive, determination and a vigour unparalleled in this modern age.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?d47062fe